import React, { useCallback, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Stack,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Box,
} from "@mui/material";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import { scrolltoView } from "../../../Utils/scrollToView";
import { useStyles } from "./styles";
import useCourse from "../../../Hooks/course";
import useSemester from "../../../Hooks/semester";
import { useNavigate } from "react-router-dom";
import useSubject from "../../../Hooks/subject";
import Loader from "../../../common/Loader";
import moment from "moment";
import CustomPagination from "../../../common/Pagination";
import usePagination from "../../../common/usePagination";
import useAuthStore from "../../../Hooks/auth";
import useCircular from "../../../Hooks/circular";
import ToggleSwitch from "../../../common/ToggleSwitch";
import { getStatusInBoolen, getToggleStatus } from "../../../Utils/deleteutils";

const current = moment(new Date()).format("YYYY");

const columns = [
  {
    id: "s.no",
    label: "S.No",
    align: "center",
    sortby: true,
  },
  {
    id: "name",
    label: "Subject Name",
    align: "center",
    sortby: true,
  },
  {
    id: "courseName",
    label: "Course",
    align: "center",
    sortby: true,
  },
  {
    id: "edit",
    label: "Edit",
    align: "center",
  },
  {
    id: "delete",
    label: "Actions",
    align: "center",
  },
];

const SemesterSchema = Yup.object().shape({
  idCourse: Yup.string().required("* Please select Course"),
  semesterYear: Yup.number()
    .integer()
    .min(1900, "* Year must be greater then 1900")
    .max(2100, "* Year must be less then 2100")
    .required("* Please enter year"),
  name: Yup.string().required("* Please enter semester"),
  // startDate: Yup.number().required("* Please select start date"),
  // endDate: Yup.number().required("* Please select end date"),
});

const SemesterManagement = (props) => {
  const classes = useStyles();
  const { getAllCourseAction, courseData } = useCourse();
  const {
    getSubjectAction,
    subjectData,
    deleteSubjectAction,
    loading,
    redirect,
    setRidirectAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useSubject();

  const { addSemesterAction, loadingSem } = useSemester();
  const navigate = useNavigate();
  // const [PerPage, setPerPage] = useState(10);
  // const [page, setPage] = useState(1);
  const { institutionId } = useAuthStore();

  const initValues = {
    idCourse: "",
    semesterYear: current,
    name: "",
    startDate: "",
    endDate: "",
    institutionId: institutionId,
  };

  const handlePage = (e) => {
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      // _DATA.jump(p);
    },
    [perPage, page]
  );

  const count =
  (subjectData &&
    Math.ceil(
      (subjectData?.totalNoOfRecord?.totalNoOfRecord || 0) / perPage
    )) ||
  0;
  // const count =
  //   (subjectData &&
  //     Math.ceil(subjectData?.totalNoOfRecord?.totalNoOfRecord / perPage)) ||
  //   0;
  const _DATA = usePagination(subjectData?.subject, perPage);

  //console.log("subjectData.length >= 0", subjectData);
  console.group("SemesterManagement");
  console.log("subjectData", subjectData);
  console.log("courseData", courseData);
  console.log("currentPageData", _DATA, _DATA.currentData());
  console.groupEnd("SemesterManagement");
  React.useEffect(() => {}, [page, perPage]);

  React.useLayoutEffect(() => {
    getAllCourseAction({
      course: {
        limit: 10,
        offSet: 0,
        institutionId,
      },
    });
    getSubjectAction({ 
      institutionId: institutionId,
      limit: perPage,
      offset: offset,
    });
  }, [institutionId,perPage, offset]);

  React.useEffect(() => {
    if (redirect === true) {
      scrolltoView(`#subjectList`);
    }
    return () => {
      setRidirectAction();
    };
  }, [redirect]);

  return (
    <>
      {(loading || loadingSem) && <Loader />}

      <Grid container className={classes.semesterList}>
        <Grid item lg={5} xs={12} md={6}>
          <Stack className={classes.align}>
            <Formik
              validationSchema={SemesterSchema}
              initialValues={initValues}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={(values) => {
                //console.log("addSemesterAction", values);
                addSemesterAction(values);
              }}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                } = formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <Stack>
                      <Typography className={classes.title} sx={{ pb: 2 }}>
                        Add Semester
                      </Typography>
                    </Stack>
                    <Stack className={classes.formView}>
                      <Typography className={classes.input_label}>
                        Course
                      </Typography>
                      <Stack>
                        <Select
                          id="idCourse"
                          name="idCourse"
                          placeholder="Choose course"
                          onChange={handleChange}
                          IconComponent={CustomExpandMore}
                          sx={{
                            width: 252,
                            marginLeft: "70px",
                          }}
                          value={values.idCourse}
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select Course
                          </MenuItem>
                          {courseData &&
                            courseData?.course?.map((_el, index) => (
                              <MenuItem value={_el.id} key={index}>
                                {_el.name}
                              </MenuItem>
                            ))}
                        </Select>
                        <ErrorMessage
                          name="idCourse"
                          component="span"
                          className={[classes.error, classes.selectError].join(
                            " "
                          )}
                        />
                      </Stack>
                    </Stack>

                    <br />
                    <Stack className={classes.formView}>
                      <Typography className={classes.input_label}>
                        Year
                      </Typography>
                      <Stack>
                        <TextField
                          id="semesterYear"
                          name="semesterYear"
                          type="number"
                          sx={{
                            width: 252,
                            marginLeft: "95px",
                          }}
                          placeholder="YYYY"
                          // inputProps={{ min: 1900, max: 2100 }}
                          className={
                            errors.semesterYear && touched.semesterYear
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.semesterYear}
                        />

                        <ErrorMessage
                          name="semesterYear"
                          component="span"
                          className={[classes.error, classes.selectError].join(
                            " "
                          )}
                        />
                      </Stack>
                    </Stack>
                    <br />
                    <Stack className={classes.formView}>
                      <Typography className={classes.input_label}>
                        Semester
                      </Typography>
                      <Stack>
                        <TextField
                          sx={{
                            width: 252,
                            marginLeft: "48px",
                          }}
                          id="name"
                          name="name"
                          placeholder="Enter name"
                          className={
                            errors.name && touched.name
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.name}
                        />
                        <ErrorMessage
                          name="name"
                          component="span"
                          className={[classes.error, classes.selectError].join(
                            " "
                          )}
                        />
                      </Stack>
                    </Stack>
                    <br />
                    <Box
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        display: "flex",
                        // gap: 2,
                      }}
                    >
                      <Typography>Start Date</Typography>
                      <TextField
                        id="startDate"
                        type="date"
                        name="startDate"
                        sx={{
                          width: 252,
                          marginLeft: "50px",
                        }}
                        value={values.startDate}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Enter Start Date"
                      />
                      <ErrorMessage
                        name="startDate"
                        component="span"
                        className={[classes.error, classes.selectError].join(
                          " "
                        )}
                      />
                    </Box>
                    <br />
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        display: "flex",
                        // gap: 2,
                      }}
                    >
                      <Typography>End Date</Typography>
                      <TextField
                        id="endDate"
                        type="date"
                        name="endDate"
                        sx={{
                          width: 252,
                          marginLeft: "50px",
                        }}
                        value={values.endDate}
                        onChange={handleChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Enter End Date"
                      />
                      <ErrorMessage
                        name="endDate"
                        component="span"
                        className={[classes.error, classes.selectError].join(
                          " "
                        )}
                      />
                    </Stack>
                    <br />
                    <Button
                      type="submit"
                      sx={{
                        width: "100%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.submit_btn}
                    >
                      Add Semester
                    </Button>
                  </form>
                );
              }}
            </Formik>
          </Stack>
        </Grid>
        <Grid item lg={10} sm={12}>
          <Stack sx={{ my: 4 }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  p: 4,
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    alignItem: "center",
                    justifyContent: "flex-end",
                    mb: 2,
                  }}
                >
                  <Button
                    type="submit"
                    sx={{ px: 3, py: 1.5, borderRadius: "50px" }}
                    className={classes.submit_btn}
                    onClick={() => navigate("/subject/add")}
                  >
                    Add Subject
                  </Button>
                </Stack>
                <TableContainer id="subjectList" sx={{ maxHeight: "440px" }}>
                  <Table
                    aria-label="sticky table"
                    className={classes.root}
                    style={{ padding: 0 }}
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow classes={{ root: classes.thead }}>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              minWidth: column.minWidth,
                              paddingLeft: column.paddingLeft,
                            }}
                            classes={{ root: classes.columnData }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody classes={{ root: classes.tBody }}>
                      {subjectData && subjectData.length !== 0 ? (
                        subjectData?.subject?.map((_el, index) => (
                          <TableRow role="checkbox" tabIndex={-1} key={index}>
                            {columns.map((column) => {
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.id === "s.no" ? (
                                    <span>{index + offset + 1}</span>
                                  ) : column.id === "name" ? (
                                    _el.name
                                  ) : column.id === "courseName" ? (
                                    _el.courseName
                                  ) : column.id === "edit" ? (
                                    <Stack
                                      sx={{
                                        alignItems: "center",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        navigate("/subject/edit", {
                                          state: { id: _el.id },
                                        })
                                      }
                                    >
                                      <img src={Pen} alt="pen" />
                                    </Stack>
                                  ) : (
                                    <Stack
                                      sx={{
                                        alignItems: "center",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        deleteSubjectAction({
                                          id: _el.id,
                                          status: getToggleStatus(_el.status),
                                        })
                                      }
                                    >
                                      <ToggleSwitch
                                        defaultChecked
                                        checked={getStatusInBoolen(_el.status)}
                                      />
                                    </Stack>
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={columns.length}
                            sx={{ borderBottom: "none" }}
                          >
                            <Stack
                              sx={{
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              No Data
                            </Stack>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                {subjectData?.totalNoOfRecord?.totalNoOfRecord > 10 && (
                  <CustomPagination
                    count={count}
                    page={page}
                    onPageChange={handleChange}
                    handlePage={handlePage}
                    perPage={perPage}
                  />
                )}
              </Paper>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default SemesterManagement;
